import ErrorComponent from './error-component.tsx';

export default ErrorComponent;
